import React, { useContext, useEffect, useState } from "react"
import * as AppConstants from "@/utility/AppConstants"
//import InfoRiservatezza from '../../avvisi/InfoRiservatezza';
import TabRicaviCompensi from "../include/multiAnno/TabRicaviCompensi"
import TabValoreAggiunto from "../include/multiAnno/TabValoreAggiunto"
import TabReddito from "../include/multiAnno/TabReddito"
import TabIndicatori from "../include/multiAnno/TabIndicatori"
import TabGestioneCaratteristica from "../include/multiAnno/TabGestioneCaratteristica"
import TabRedditivita from "../include/multiAnno/TabRedditivita"
import TabGestioneExtra from "../include/multiAnno/TabGestioneExtra"
import TabIndicatoriSpecifici from "../include/multiAnno/TabIndicatoriSpecifici"
import TabAnomalie from "../include/multiAnno/TabAnomalie"
import TabTitle from "../include/TabTitle"
import HeaderTable from "../../../table/multiAnno/HeaderTable"
import BodyTable from "../../../table/multiAnno/BodyTable"
import {
    Table,
    SimpleCard,
    Collapsible,
    Messages
} from "@sogei/react-web-components-catalog"
import { ResponseDatiNazionaliMultiAnno } from "@/utility/model"
import axios from "axios"
import { MultiAnnoContext } from "@/context/MultiAnnoContext"
import InfoRiservatezza from "@/components/avvisi/InfoRiservatezza"
import BodyTableCPB from "@/components/table/multiAnno/BodyTableCpb"
import HeaderTotaliCPB from "@/components/table/multiAnno/HeaderTableTotaliCPB"

function TabSocietaPersone(props: any) {
    const [datiNazionali, setDatiNazionali] = useState<
        ResponseDatiNazionaliMultiAnno[]
    >([])
    const anni = datiNazionali.map((dati) => dati.anno)

    const [multiAnnoState, multiAnnoDispatch] = useContext(MultiAnnoContext)

    const fetchDati = () => {
        let url = AppConstants.URL_GET_DATI_NAZIONALI_MULTI_ANNO

        const CancelToken = axios.CancelToken
        const source = CancelToken.source()
        let macroArea =
            props.macroarea == undefined || props.macroarea == ""
                ? "@@"
                : props.macroarea

        let codiceIsa =
            props.codIsa == undefined || props.codIsa == ""
                ? "@@"
                : props.codIsa
        return axios
            .get(url, {
                params: {
                    anno: props.anno,
                    codIsa: codiceIsa,
                    macroarea: macroArea,
                    natGiuridica: "5",
                    cancelToken: source.token
                }
            })
            .then((response) => {
                if (response.data.length > 0) {
                    setDatiNazionali(response.data)
                    multiAnnoDispatch({
                        type: "setSocietaPersone",
                        value: {
                            societaPersone: (
                                response.data as ResponseDatiNazionaliMultiAnno[]
                            ).map((d) => ({
                                numeroPosizioni: d.numPosizioni.toString(),
                                anno: d.anno
                            }))
                        }
                    })
                } else {
                }
            })
            .catch((err) => {
                console.log("err: ", err)
            })
    }

    useEffect(() => {
        fetchDati()

        return () => {}
    }, [])

    let codiciIsa = datiNazionali.map((d) => d.codIsa)

    return (
        <div id="tab-societa-persone">
            <TabTitle title={AppConstants.TITLE_SOCIETA_PERSONE} {...props} />

            <div className="row">
                <div className="col-12">
                    <SimpleCard
                        cardType="default"
                        title={""}
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTable
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                            anni={anni}
                                            codici={codiciIsa}
                                        />
                                    }
                                    tableBody={
                                        <BodyTable
                                            isCampo1={true}
                                            isCampo2={true}
                                            isCampo3={true}
                                            campo1={datiNazionali[0]}
                                            campo2={datiNazionali[1]}
                                            campo3={datiNazionali[2]}
                                        />
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_SOCIETA_PERSONE}{" "}
                                    </caption>
                                </Table>
                            </div>
                        }
                    />
                </div>
            </div>
            {anni.some((x) => multiAnnoState.rangeAnni.get(Number(x))) && (
                <>
                    <div className="row">
                        <div className="col-12">
                            <h1 className="h3"> {AppConstants.TITLE_CPB} </h1>
                        </div>
                    </div>
                    <div className="row">
                        <div className="col-12">
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTotaliCPB
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                            anni={anni.map((x) =>
                                                !multiAnnoState.rangeAnni.get(
                                                    Number(x)
                                                )
                                                    ? ""
                                                    : Number(x) +
                                                      1 +
                                                      "/" +
                                                      (Number(x) + 2)
                                            )}
                                        />
                                    }
                                    tableBody={
                                        <>
                                            <BodyTableCPB
                                                isCampo1={true}
                                                isCampo2={true}
                                                isCampo3={true}
                                                campo1={datiNazionali[0]}
                                                campo2={datiNazionali[1]}
                                                campo3={datiNazionali[2]}
                                            />
                                        </>
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_CPB}{" "}
                                    </caption>
                                </Table>
                            </div>
                        </div>
                    </div>
                </>
            )}

            <div className="row">
                <div className="col-12">
                    <h1 className="h3"> {AppConstants.DATI_AFFIDABILITA} </h1>
                </div>
            </div>
            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_RICAVI_COMPENSI}
                        titleHeading="h3"
                        body={
                            <>
                                <div className="table-responsive">
                                    <Table
                                        tableHead={
                                            <HeaderTable
                                                codIsa={props.codIsa}
                                                macroarea={props.macroarea}
                                                anni={anni}
                                                codici={codiciIsa}
                                            />
                                        }
                                        tableBody={
                                            <TabRicaviCompensi
                                                isCampo1={true}
                                                isCampo2={true}
                                                isCampo3={true}
                                                campo1={datiNazionali[0]}
                                                campo2={datiNazionali[1]}
                                                campo3={datiNazionali[2]}
                                            />
                                        }
                                        tableOptions={["table-striped"]}
                                    >
                                        <caption className="sr-only">
                                            {AppConstants.TITLE_SOCIETA_PERSONE}{" "}
                                            -{" "}
                                            {AppConstants.DATI_RICAVI_COMPENSI}
                                        </caption>
                                    </Table>
                                </div>
                                <div className="info_ricavi_compensi">
                                    {AppConstants.INFO_RICAVI_COMPENSI}
                                </div>
                            </>
                        }
                        id="DATI_RICAVI_COMPENSI"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_VALORE_AGGIUNTO}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTable
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                            anni={anni}
                                            codici={codiciIsa}
                                        />
                                    }
                                    tableBody={
                                        <TabValoreAggiunto
                                            isCampo1={true}
                                            isCampo2={true}
                                            isCampo3={true}
                                            campo1={datiNazionali[0]}
                                            campo2={datiNazionali[1]}
                                            campo3={datiNazionali[2]}
                                        />
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_SOCIETA_PERSONE} -{" "}
                                        {AppConstants.DATI_VALORE_AGGIUNTO}
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="DATI_VALORE_AGGIUNTO"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_REDDITO}
                        titleHeading="h3"
                        body={
                            <>
                                <div className="table-responsive">
                                    <Table
                                        tableHead={
                                            <HeaderTable
                                                codIsa={props.codIsa}
                                                macroarea={props.macroarea}
                                                anni={anni}
                                                codici={codiciIsa}
                                            />
                                        }
                                        tableBody={
                                            <TabReddito
                                                isCampo1={true}
                                                isCampo2={true}
                                                isCampo3={true}
                                                campo1={datiNazionali[0]}
                                                campo2={datiNazionali[1]}
                                                campo3={datiNazionali[2]}
                                            />
                                        }
                                        tableOptions={["table-striped"]}
                                    >
                                        <caption className="sr-only">
                                            {AppConstants.TITLE_SOCIETA_PERSONE}{" "}
                                            - {AppConstants.DATI_REDDITO}
                                        </caption>
                                    </Table>
                                </div>
                                <div className="info_ricavi_compensi">
                                    {AppConstants.INFO_REDDITO}
                                </div>
                            </>
                        }
                        id="DATI_REDDITO"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_INDICATORI_ELEM_AFF}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTable
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                            anni={anni}
                                            codici={codiciIsa}
                                        />
                                    }
                                    tableBody={
                                        <TabIndicatori
                                            isCampo1={true}
                                            isCampo2={true}
                                            isCampo3={true}
                                            campo1={datiNazionali[0]}
                                            campo2={datiNazionali[1]}
                                            campo3={datiNazionali[2]}
                                        />
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_SOCIETA_PERSONE} -{" "}
                                        {AppConstants.DATI_INDICATORI_ELEM_AFF}
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="DATI_INDICATORI_ELEM_AFF"
                    />
                </div>
            </div>
            <div className="row">
                <div className="col-12">&nbsp;</div>
            </div>
            <div className="row">
                <div className="col-12">
                    <h1 className="h3"> {AppConstants.DATI_ANOMALIA} </h1>
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_ANOMALIA_GESTIONE_CAR}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTable
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                            anni={anni}
                                            codici={codiciIsa}
                                        />
                                    }
                                    tableBody={
                                        <TabGestioneCaratteristica
                                            isCampo1={true}
                                            isCampo2={true}
                                            isCampo3={true}
                                            campo1={datiNazionali[0]}
                                            campo2={datiNazionali[1]}
                                            campo3={datiNazionali[2]}
                                        />
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_SOCIETA_PERSONE} -{" "}
                                        {AppConstants.DATI_ANOMALIA} -{" "}
                                        {
                                            AppConstants.DATI_ANOMALIA_GESTIONE_CAR
                                        }
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="DATI_ANOMALIA_GESTIONE_CAR"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_ANOMALIA_REDDITIVITA}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTable
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                            anni={anni}
                                            codici={codiciIsa}
                                        />
                                    }
                                    tableBody={
                                        <TabRedditivita
                                            isCampo1={true}
                                            isCampo2={true}
                                            isCampo3={true}
                                            campo1={datiNazionali[0]}
                                            campo2={datiNazionali[1]}
                                            campo3={datiNazionali[2]}
                                        />
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_SOCIETA_PERSONE} -{" "}
                                        {AppConstants.DATI_ANOMALIA}-{" "}
                                        {AppConstants.DATI_ANOMALIA_REDDITIVITA}
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="DATI_ANOMALIA_REDDITIVITA"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_ANOMALIA_GESTIONE_EXTRA}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTable
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                            anni={anni}
                                            codici={codiciIsa}
                                        />
                                    }
                                    tableBody={
                                        <TabGestioneExtra
                                            isCampo1={true}
                                            isCampo2={true}
                                            isCampo3={true}
                                            campo1={datiNazionali[0]}
                                            campo2={datiNazionali[1]}
                                            campo3={datiNazionali[2]}
                                        />
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_SOCIETA_PERSONE} -{" "}
                                        {AppConstants.DATI_ANOMALIA}-{" "}
                                        {
                                            AppConstants.DATI_ANOMALIA_GESTIONE_EXTRA
                                        }
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="DATI_ANOMALIA_GESTIONE_EXTRA"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_ANOMALIA_INDICATORI_SPECIFICI}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTable
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                            anni={anni}
                                            codici={codiciIsa}
                                        />
                                    }
                                    tableBody={
                                        <TabIndicatoriSpecifici
                                            isCampo1={true}
                                            isCampo2={true}
                                            isCampo3={true}
                                            campo1={datiNazionali[0]}
                                            campo2={datiNazionali[1]}
                                            campo3={datiNazionali[2]}
                                        />
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_SOCIETA_PERSONE} -{" "}
                                        {AppConstants.DATI_ANOMALIA} -{" "}
                                        {
                                            AppConstants.DATI_ANOMALIA_INDICATORI_SPECIFICI
                                        }
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="DATI_ANOMALIA_INDICATORI_SPECIFICI"
                    />
                </div>
            </div>

            <div className="row">
                <div className="col-12">
                    <Collapsible
                        cardType="default"
                        title={AppConstants.DATI_ANOMALIA_ALTRI_INDICATORI}
                        titleHeading="h3"
                        body={
                            <div className="table-responsive">
                                <Table
                                    tableHead={
                                        <HeaderTable
                                            codIsa={props.codIsa}
                                            macroarea={props.macroarea}
                                            anni={anni}
                                            codici={codiciIsa}
                                        />
                                    }
                                    tableBody={
                                        <TabAnomalie
                                            isCampo1={true}
                                            isCampo2={true}
                                            isCampo3={true}
                                            campo1={datiNazionali[0]}
                                            campo2={datiNazionali[1]}
                                            campo3={datiNazionali[2]}
                                        />
                                    }
                                    tableOptions={["table-striped"]}
                                >
                                    <caption className="sr-only">
                                        {AppConstants.TITLE_SOCIETA_PERSONE} -{" "}
                                        {AppConstants.DATI_ANOMALIA} -{" "}
                                        {
                                            AppConstants.DATI_ANOMALIA_ALTRI_INDICATORI
                                        }
                                    </caption>
                                </Table>
                            </div>
                        }
                        id="DATI_ANOMALIA_ALTRI_INDICATORI"
                    />
                </div>
            </div>
            <InfoRiservatezza />
        </div>
    )
}

export default TabSocietaPersone
